/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import classNames from 'classnames';
import PropTypes from 'prop-types';

// Component imports
import { Select, Space, Tooltip, Typography } from 'antd';
import { ALPHANUMERIC_HYPHEN_UNDERSCORE_REGEX } from '../../constants/regex';
import { Fragment } from 'react';

// Constant declarations
const baseClassName = 'responsive-tags-list';

const ResponsiveTagsList = ({
  values,
  maxTagCount = 'responsive',
  tagRender = (tag) => tag.label,
  mode = 'multiple',
  style = { cursor: 'default' },
  direction = 'horizontal',
  omittedButtonClassName = '',
  renderOmittedValues,
  ...restProps
}) => {
  return (
    <Select
      mode={mode}
      className={classNames(baseClassName, {
        [`${baseClassName}__vertical`]: direction === 'vertical'
      })}
      open={false}
      showSearch={false}
      style={style}
      bordered={false}
      onMouseDownCapture={(e) => e.stopPropagation()}
      onMouseEnter={() => (null)}
      onInputKeyDown={(e) => {
        if (mode === 'tags' && !ALPHANUMERIC_HYPHEN_UNDERSCORE_REGEX.test(e.key)) {
          e.preventDefault();
          return false;
        }
      }}
      value={values} // Remove the first value (the one displayed in the input)
      tagRender={tagRender}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={(omittedValues) => {
        return (
          <Tooltip
            title={
              <Space
                onClick={e => e.stopPropagation()} // Added to prevent onRow onClick handler to propagate the event.
                size={4}
                direction="vertical"
                className="overflow-y-auto overflow-x-hidden scrollbar-custom"
                style={{ maxHeight: 160, maxWidth: 280 }}
              >
                {
                  renderOmittedValues ? (
                    renderOmittedValues(omittedValues)
                  ) : (
                    <Fragment>
                      {
                        omittedValues.map((omittedValue) => {
                          const matchedValue = values.find((v) => v.value === omittedValue.value);
                          return matchedValue ? (
                            <Typography.Paragraph className={`${baseClassName}__markdown-list`}>
                              <Space align="start">
                                {matchedValue.icon}
                                {matchedValue.label}
                              </Space>
                            </Typography.Paragraph>
                          ) : null;
                        })
                      }
                    </Fragment>
                  )
                }
              </Space>
            }
            placement="bottom"
          >
            <Typography.Text className={omittedButtonClassName}>
              +{omittedValues.length}
            </Typography.Text>
          </Tooltip>
        );
      }}
      {...restProps}
    />
  );
};

ResponsiveTagsList.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.string,
    icon: PropTypes.node
  })).isRequired,
  maxTagCount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['responsive'])
  ]),
  tagRender: PropTypes.func,
  mode: PropTypes.oneOf(['multiple', 'tags']),
  style: PropTypes.object,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  renderOmittedValues: PropTypes.func,
  omittedButtonClassName: PropTypes.string
};

export default ResponsiveTagsList;
